import {useAppSelector} from 'hooks';
import {ShippingFeeRule} from 'types';

export interface IBasketCalculations {
  /**
   * The default shipping fee
   */
  defaultShippingFee: number;

  /**
   * The basket amount required to achieve free shipping
   */
  freeThreshold: number;

  /**
   * List of shipping fee rules
   */
  shippingFeeRules: ShippingFeeRule[];

  /**
   * Minimum amount required to place an order
   */
  minimumBasket: number;

  priceUnit: string;
}

export function useBasketCalculations(): IBasketCalculations {
  const {basket} = useAppSelector((state) => state?.basket) || {};

  if (!basket?.prices || !basket?.shippingRule?.shippingRanges || !basket.freeShippingValue) {
    return {
      freeThreshold: 0,
      shippingFeeRules: [],
      minimumBasket: 0,
      defaultShippingFee: 0,
      priceUnit: 'THB'
    };
  }

  const priceUnit = basket.priceUnit;
  const shippingFeeRules = [...basket.shippingRule.shippingRanges].sort((a, b) => a.from - b.from);

  const [defaultShippingFeeRule] = shippingFeeRules;
  const minimumBasket = basket.shippingRule.minimumBasket || 0; // FIXME why is it defined as optional?
  const freeThreshold = basket.freeShippingValue;

  return {
    defaultShippingFee: defaultShippingFeeRule.value,
    freeThreshold,
    shippingFeeRules,
    minimumBasket,
    priceUnit
  };
}
